import NaptimeResource from './NaptimeResource';

class EnterpriseSocialProofMetrics extends NaptimeResource {
  static RESOURCE_NAME = 'enterpriseSocialProofMetrics.v1';

  static numberRealActivePrograms() {
    return this.get('number_real_active_programs', { fields: ['metricValue'] }, (data) => {
      // @ts-expect-error TODO: generate types for EnterpriseSocialProofMetrics via `yarn naptime:types enterpriseSocialProofMetrics.v1`
      return data?.metricValue;
    });
  }
}

export default EnterpriseSocialProofMetrics;
